// extracted by mini-css-extract-plugin
export default {"typography":"_2H20a6wYmkExL3FthZ3IBJ","copyInput":"_1Lu4dt_EuOYtE7XXoKV0_D"};